export const COMPARE_ONBOARDING_COUNTER_KEY = 'compare_onboarding_counter';
export const MAX_SESSION_COUNT = 1;
export const MAX_TOTAL_COUNT = 2;

export function getCount(storage: Storage) {
  const count = Number(storage.getItem(COMPARE_ONBOARDING_COUNTER_KEY));

  if (isNaN(count)) {
    return 0;
  }

  return count;
}

function incrementCount(storage: Storage, count: number) {
  storage.setItem(COMPARE_ONBOARDING_COUNTER_KEY, String(count + 1));
}

function isStoragesAvailable() {
  return typeof window !== 'undefined' && !!window.sessionStorage && !!window.localStorage;
}

export function isCompareOnboardingEnabled() {
  if (!isStoragesAvailable()) {
    return false;
  }

  const totalCount = getCount(window.localStorage);
  const sessionCount = getCount(window.sessionStorage);

  return totalCount < MAX_TOTAL_COUNT && sessionCount < MAX_SESSION_COUNT;
}

export function incrementCompareOnboardingCounter(enabled: boolean) {
  if (!isStoragesAvailable() || !enabled) {
    return;
  }

  const totalCount = getCount(window.localStorage);
  const sessionCount = getCount(window.sessionStorage);

  if (totalCount < MAX_TOTAL_COUNT) {
    incrementCount(window.localStorage, totalCount);
  }
  if (sessionCount < MAX_SESSION_COUNT) {
    incrementCount(window.sessionStorage, sessionCount);
  }
}
